export const TYPES = {
  SET_PAGINATION: 'RECEIPTS/SET_PAGINATION',
  SET_TABLE_PAGE: 'RECEIPTS/SET_TABLE_PAGE',
  ADD_TO_SELECTED: 'RECEIPTS/ADD_TO_SELECTED',
  REMOVE_FROM_SELECTED: 'RECEIPTS/REMOVE_FROM_SELECTED',
  SET_FILTERS_DATA: 'RECEIPTS/SET_FILTERS_DATA',
  SET_SELECTED_FILTERS: 'RECEIPTS/SET_SELECTED_FILTERS',
  SET_RECEIPT_READ_STATUS: 'RECEIPTS/SET_RECEIPT_READ_STATUS',
  SET_RECEIPTS_SORT_PROPERTY: 'RECEIPTS/SET_RECEIPTS_SORT_PROPERTY',
}
